import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	QueryList,
	SimpleChanges,
	ViewChild,
	ViewChildren
} from '@angular/core';
// Other
import { GalleryOptions, JPathService } from '@cv-invision/cv.component-library.ux';
// Model
import { OverviewScopeModel } from '../model/overview-scope.model';
import { Observable, Subject } from 'rxjs';
import { Store } from '@ngxs/store';
import { RulesState } from '../../rules/state/rules.state';
import { takeUntil } from 'rxjs/operators';
import { RuleModel } from '../../rules/model/rule.model';
import { UI_FIELD_SELECTED_EVENT } from '../../rules/rules.component';
import { BroadcastService } from '@cv-invision/core';
import { SCHEMA_TYPE } from '../../model/quality.constant';
import { OverviewCVDSModel } from '../model/overview-cvds.model';
import { OrderDetailModel } from '../../state/model/order-detail.model';

@Component({
	selector: 'cv-scope-overview',
	templateUrl: './overview.fields.html',
	styleUrls: ['../overview.component.scss']
})
export class OverviewFieldsComponent implements OnInit, OnChanges, OnDestroy {
	rules$: Observable<any> = this.store.select(RulesState.getOrderRules);
	@ViewChild('gallery', { static: false }) gallery: any;
	@ViewChildren('overviewFailed') overviewFailed: QueryList<ElementRef>;
	@ViewChildren('changesEl') btnChanges: QueryList<ElementRef>;
	@Input() photosCollection: any = [];
	@Input() targets = [];
	@Input() documentOrder: any;
	@Input() Addresdescription: string;
	@Input() selectedRule: any;
	@Input() orderDetailModel: OrderDetailModel;
	@Output() historicalVa: EventEmitter<any> = new EventEmitter<any>();

	public rules: any;
	public changePreviewIndex: boolean;
	dataModel: any; // dataModel
	historicalOpt: any;
	csshighlight: string;
	target = [];

	galleryOptions: GalleryOptions = {
		noFilesImage: 'assets/img/placeholder/nofiles.png',
		showCounters: false,
		showPreview: true,
		showDescription: false,
		hasSelected: false,
		size: {
			width: '300px',
			height: '225px'
		}
	};

	private atComponentDestroy = new Subject();

	constructor(
		private broadcastService: BroadcastService,
		private jPathService: JPathService,
		private store: Store
	) {
		this.historicalOpt = {
			hasH: false,
			length: 0
		};
	}

	ngOnInit(): void {
		this.setModelOrder();
		this.rules$.pipe(takeUntil(this.atComponentDestroy)).subscribe((orderRules: any) => {
			this.rules = orderRules;
		});
	}

	/**
	 * set what type of model it is needed for any type of order
	 */
	setModelOrder(): void {
		if (this.orderDetailModel.schema === SCHEMA_TYPE.INSPECTION_R) {
			if (this.orderDetailModel.formType === 'FNMA') {
				const model = Object.assign([], new OverviewCVDSModel().CVDS);
				this.dataModel = model.map(f => {
					const { title, items } = f;
					return {
						title,
						items: items.filter(i => !i.freddie)
					};
				});
			} else {
				this.dataModel = new OverviewCVDSModel().CVDS;
			}
		} else {
			this.dataModel = new OverviewScopeModel().F1004;
		}
	}

	/**
	 * return the proper value base on the path model and set historical value as well
	 * @param path
	 */
	getDocValue(path: string): string {
		const field = this.jPathService.getValue(this.documentOrder, `$.${path}`);

		if (field) {
			if (field.Historical) {
				this.historicalOpt = {
					hasH: !!field.Historical.length,
					length: field.Historical.length
				};
			}

			if (path === this.dataModel[0].items[0].path) {
				return this.Addresdescription;
			}

			if (
				this.orderDetailModel.schema !== SCHEMA_TYPE.INSPECTION_R &&
				path === this.dataModel[0].items[1].path
			) {
				const format = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD'
				});
				return `${format.format(field.Value)} USD`;
			}
		}
		return field ? field.Value : ' ';
	}

	/**
	 * some freddie order has more than one value to display ina single cell, this function handles this
	 * @param values
	 */
	getDocIterable(values: any): string {
		const i = this.jPathService.getValue(this.documentOrder, `$.${values.source}`)[0];
		let data;
		if (values.items.length === 1) {
			data = `${i[values.items[0]].Value}`;
		} else {
			data = `${i[values.items[0]].Value}-${i[values.items[1]].Value}`;
		}

		return data;
	}

	/**
	 * emit the path for the field selected
	 * @param path
	 */
	onFieldSelected(path: string): void {
		let rules = this.getFieldRules(path);

		if (rules.length) {
			// TODO: remove this when back-end fix the issue
			if (rules.length > 1) {
				rules = rules.filter(r => r.uiSection.toLocaleLowerCase() === 'overview');
			}
			this.broadcastService.broadcast({
				name: UI_FIELD_SELECTED_EVENT,
				event: {
					fieldPath: path,
					rule: rules[0]
				}
			});
		}
	}

	/**
	 * emit the path for the field selected
	 * @param path
	 */
	onFieldHasRule(path: string): boolean {
		const rules = this.getFieldRules(path);
		return rules.length > 0;
	}

	/**
	 * Return the rules asigned to the field
	 * @param fieldPath
	 */
	getFieldRules(fieldPath: string): Array<RuleModel> {
		const field = fieldPath.replace(/[^a-zA-Z ]/g, '').toLowerCase();
		const rules: RuleModel[] = this.rules.violation.filter(rule => {
			let isAvailable = false;
			if (rule.targets.length) {
				const targets = rule.targets
					.join()
					.replace(/[^a-zA-Z ]/g, '')
					.toLowerCase();
				isAvailable = targets.indexOf(field) !== -1;
			}
			return isAvailable;
		});

		return rules;
	}

	/**
	 * emit the path for the field selected
	 * @param path
	 */
	onHistoricalVal(path: string, changesEl: any): void {
		this.historicalVa.emit({ path, ele: changesEl, btns: this.btnChanges });
	}

	/**
	 * Initialize change preview index when preview is open
	 */
	onGalleryPreviewOpened(): void {
		this.changePreviewIndex = true;
	}

	/**
	 * Open the correct preview according with the gallery image index
	 */
	onGalleryPreviewChange(): void {
		if (
			this.changePreviewIndex &&
			this.gallery.image.selectedIndex !== this.gallery.preview.index
		) {
			this.gallery.openPreview(this.gallery.image.selectedIndex);
			this.changePreviewIndex = false;
		} else {
			this.gallery.show(this.gallery.preview.index);
		}
	}

	/**
	 * get the rule selected
	 * @param item selected rule model
	 */
	getSelectedRule(data: any): void {
		const { target } = data;
		const failedElements = this.overviewFailed.toArray();
		const failedElement = failedElements.filter(r =>
			target.includes(r.nativeElement.attributes.path.value)
		);
		if (failedElement.length) {
			failedElement[0].nativeElement.scrollIntoView(
				window.innerHeight < 750 ? false : { behavior: 'smooth', block: 'start' }
			);
		}
	}

	// checks whether is a selected rule has changed
	ngOnChanges(changes: SimpleChanges): void {
		if (changes.selectedRule) {
			const { currentValue } = changes.selectedRule;
			if (currentValue.target) {
				this.csshighlight = currentValue.type;
				this.target = currentValue.target;
				this.getSelectedRule(currentValue);
			}
		}
	}

	/**
	 * Close all when the element is destroyed
	 * in case a Sub Component remains visible
	 */
	ngOnDestroy(): void {
		// Globally Destroy anything attached to it
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
